import * as Yup from 'yup';
import { FC, useState } from 'react';
import { useFormik } from 'formik';
import {
  Container,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Button,
  MenuItem,
  Typography,
  Autocomplete
} from '@mui/material';
import TextField from '@mui/material/TextField';
import request from '../../../../utils/request';
import { LoadingButton } from '@mui/lab';
import SnackbarAlert from '../../../common/SnackbarAlert';
import React from 'react';
import AutocompleteLoader from '../../../common/AutocompleteLoader';
type CreateEditProps = {
  closeCreateEditForm: any;
  occupancyEditDatas: any;
  editStatus: boolean;
  productId: any;
  setNewValue?: Function;
};
const CreateEdit: FC<CreateEditProps> = ({
  closeCreateEditForm,
  occupancyEditDatas,
  editStatus,
  productId,
  setNewValue
}) => {
  const OccupancySchema = Yup.object().shape({
    section: Yup.string()
      .required('Section is required')
      .trim('Occupancy cannot include leading and trailing spaces'),
    occupancyName: Yup.string()
      .required('Occupancy Name is required')
      .min(2, 'Occupancy Name must be at least 2 characters'),
      // .strict(true)
      // .matches(
      //   /^[a-zA-Z0-9\s\[\]\-\(\)&\/\\]*$/,
      //   'Occupancy Name only accepts special characters like &,[,],-,/,(,)'
      // )
      // .matches(
      //   /[a-zA-Z]/,
      //   'Occupancy Name at least one alphabet letter is required'
      // ),
    // productId: Yup.string()
    //   .required('Product is required')
    //   .typeError('Product is required'),
    occupancyDescription: Yup.string()
      .min(3, 'Occupancy Description must be at least 3 characters ')
      .trim('Occupancy Description cannot include leading and trailing spaces')
      .typeError('Occupancy Description is required'),
    occupancyCode: Yup.string()
      .typeError('Occupancy Code is required')
      // .matches(
      //   /^[a-zA-Z0-9\s\-]+$/,
      //   'Invalid Occupancy Code. Only (-) symbol is allowed'
      // )
      // .matches(
      //   /^[^-!@#$%^&*()_+={};:'",.<>/?\\|[\]`~].*$/,
      //   'Occupation Code cannot start with a special character'
      // )
      .trim('Occupancy Code cannot include leading and trailing spaces'),
      // .test(
      //   'len',
      //   'Length is too long',
      //   (val) =>
      //     !val ||
      //     (val && val.toString().includes('.')
      //       ? val.toString().length <= 10
      //       : val.toString().length <= 8)
      // ),
    lossCost: Yup.number()
      .notRequired()
      .typeError('Loss Cost is not valid')
      .positive('Must be a positive number.')
      .min(0.01, 'Loss Cost must have at most two decimal places if have more than two decimal places')
      .transform((value, originalValue) => {
        return /\s/.test(originalValue) ? NaN : value;
      })
      .test('len', 'Length is too long', (val) => {
        if (val === undefined || val === null) return true;
        const valStr = val.toString();
        const maxLength = valStr.includes('.') ? 10 : 8;
        return valStr.length <= maxLength;
      })
      .test(
        'max-two-decimals',
        'Loss Cost must have at most two decimal places',
        (value) => {
          if (value === undefined || value === null) return true;
          const decimalPlaces = value.toString().split('.')[1];
          return !decimalPlaces || decimalPlaces.length <= 2;
        }
      )
      .nullable()
    // Yup.number()
    //   .transform((value, originalValue) =>
    //     /\s/.test(originalValue) ? NaN : value
    //   )

    //   .typeError('Loss Cost must be a valid number')
    //   .positive('Must be a positive number.')
    //   .min(1, 'Loss Cost must be greater than or equal to 1')
    //   .test(
    //     'len',
    //     'Length is too long',
    //     (val) => !val || (val && val.toString().length <= 10)
    //   )
  });

  const [loader, setLoader] = useState(false);
  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });
  const [noOptionsTextFlag, setNoOptionsTextFlag] = useState(false);
  const [policyProductData, setPolicyProductData] = useState([]);
  const [policyProductValue, setPolicyProductValue] = useState('');
  const [policyProductSearchValue, setPolicyProductSearchValue] = useState('');
  const [productLoader, setProductLoader] = React.useState(null);

  const formik = useFormik({
    initialValues: {
      id: '',
      section: '',
      occupancyDescription: '',
      occupancyCode: '',
      lossCost: '',
      status: true,
      occupancyName: '',
      productId: ''
    },
    validationSchema: OccupancySchema,
    onSubmit: (values) => {
      values.productId = productId;
      setLoader(true);
      const method = editStatus ? 'PUT' : 'POST';
      request({
        url: 'occupancy',
        method: method,
        data: values
      })
        .then((occupancy) => {
          if (occupancy.status) {
            closeCreateEditForm(true);
            setLoader(false);
            if (setNewValue) {
              setNewValue(values?.occupancyName);
            }
          } else {
            setLoader(false);
            setShowSnackBarAlert({
              status: true,
              type: 'error',
              message: occupancy['message']
            });
          }
        })
        .catch(function (err) {
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: err.message
          });
          setLoader(false);
        });
    }
  });

  const capitalizeFirst = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  if (editStatus) {
    formik.values.id = occupancyEditDatas.id;
    formik.initialValues.section = occupancyEditDatas.section;
    formik.initialValues.occupancyDescription =
      occupancyEditDatas.occupancyDescription === null
        ? (occupancyEditDatas.occupancyDescription = '')
        : occupancyEditDatas.occupancyDescription;
    formik.initialValues.occupancyCode =
      occupancyEditDatas.occupancyCode === null
        ? (occupancyEditDatas.occupancyCode = '')
        : occupancyEditDatas.occupancyCode;
    formik.initialValues.lossCost =
      occupancyEditDatas.lossCost === null
        ? (occupancyEditDatas.lossCost = '')
        : occupancyEditDatas.lossCost;
    formik.initialValues.occupancyName = occupancyEditDatas.occupancyName;
  }
  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  React.useEffect(() => {
    getpolicyProductData();
  }, [policyProductSearchValue]);

  const getpolicyProductData = () => {
    setProductLoader(true);
    setPolicyProductData([]);
    request({
      url: 'policyProduct/getAllowedPolicyProducts',
      method: 'post'
    }).then(
      (response: any) => {
        setProductLoader(false);
        if (response?.status == false) {
          setNoOptionsTextFlag(true);
          setPolicyProductData([]);
          setShowSnackBarAlert({
            status: true,
            type: 'error',
            message: response.message
          });
        } else {
          setNoOptionsTextFlag(false);
          setPolicyProductData(response);
        }
      },
      (error) => {
        setProductLoader(false);
        console.log(error);
      }
    );
  };

  React.useEffect(() => {
    if (editStatus) {
      formik.initialValues.productId = occupancyEditDatas.productId;
      setPolicyProductSearchValue(occupancyEditDatas.product?.name);
      setPolicyProductValue(occupancyEditDatas.product);
    }
  }, [editStatus]);

  return (
    <>
      <SnackbarAlert
        showSnackBarAlert={showSnackBarAlert}
        handleSnackbarClose={handleSnackbarClose}
      />
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <Card>
              {editStatus ? (
                <CardHeader title="Update Occupancy" />
              ) : (
                <CardHeader title="Create Occupancy" />
              )}
              <Divider />

              <CardContent>
                <form onSubmit={formik.handleSubmit}>
                  <Grid container spacing={2}>
                    {/* <Grid item xs={4}>
                      <Autocomplete
                        id="productId"
                        noOptionsText={
                          noOptionsTextFlag ? 'No Products' : 'No Data Found'
                        }
                        getOptionLabel={(policyData) => ` ${policyData?.name} `}
                        options={policyProductData}
                        isOptionEqualToValue={(option, value) =>
                          option?.name == value?.name
                        }
                        size={'small'}
                        onChange={(event: any, newValue: any) => {
                          if (newValue) {
                            setPolicyProductValue(newValue);
                            setPolicyProductSearchValue(newValue.name);
                            formik.values.productId = newValue.id;
                            formik.initialValues.productId = newValue.id;
                            formik.handleChange(event);
                          } else {
                            setPolicyProductValue('');
                            setPolicyProductSearchValue('');
                            formik.values.productId = '';
                            formik.initialValues.productId = '';
                          }
                        }}
                        onBlur={formik.handleBlur}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason == 'input') {
                            setPolicyProductSearchValue(newInputValue);
                            if (newInputValue === '') {
                              formik.values.productId = null;
                              formik.initialValues.productId = null;
                              setPolicyProductValue('');
                            }
                          }
                        }}
                        inputValue={policyProductSearchValue}
                        loading={productLoader}
                        renderInput={(params) => (
                          <TextField
                            value={policyProductValue}
                            {...params}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <AutocompleteLoader
                                  params={params}
                                  loader={productLoader}
                                />
                              )
                            }}
                            label={
                              <React.Fragment>
                                Select Product{' '}
                                <Typography
                                  component="span"
                                  sx={{ color: 'red' }}
                                >
                                  *
                                </Typography>
                              </React.Fragment>
                            }
                            name="policyProductId"
                            placeholder="Search Product"
                            error={
                              formik.touched.productId &&
                              Boolean(formik.errors.productId)
                            }
                            helperText={
                              formik.touched.productId &&
                              formik.errors.productId
                            }
                          />
                        )}
                      />
                    </Grid> */}

                    <Grid item xs={4}>
                      <TextField
                        select
                        name="section"
                        sx={{ width: '100%' }}
                        size="small"
                        type="text"
                        label={
                          <React.Fragment>
                            Select Section{' '}
                            <Typography component="span" sx={{ color: 'red' }}>
                              *
                            </Typography>
                          </React.Fragment>
                        }
                        value={formik.values.section}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.section &&
                          Boolean(formik.errors.section)
                        }
                        helperText={
                          formik.touched.section && formik.errors.section
                        }
                      >
                        <MenuItem value="Section III">Section III</MenuItem>
                        <MenuItem value="Section IV">Section IV</MenuItem>
                        <MenuItem value="Section V">Section V</MenuItem>
                        <MenuItem value="Section VI">Section VI</MenuItem>
                        <MenuItem value="Section VII">Section VII</MenuItem>
                      </TextField>
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        label={
                          <React.Fragment>
                            Occupancy Name{' '}
                            <Typography component="span" sx={{ color: 'red' }}>
                              *
                            </Typography>
                          </React.Fragment>
                        }
                        sx={{ width: '100%' }}
                        size="small"
                        name="occupancyName"
                        value={formik.values.occupancyName}
                        onChange={formik.handleChange}
                        // onBlur={formik.handleBlur}
                        onBlur={(e) => {
                          // Trim leading and trailing spaces on blur
                          const trimmedValue = e.target.value.trim();
                          formik.setFieldValue('occupancyName', trimmedValue);
                          formik.handleBlur(e); // ensure Formik's onBlur is called
                        }}
                        error={
                          formik.touched.occupancyName &&
                          Boolean(formik.errors.occupancyName)
                        }
                        helperText={
                          formik.touched.occupancyName &&
                          formik.errors.occupancyName
                        }
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        label="Occupancy Code"
                        sx={{ width: '100%' }}
                        size="small"
                        name="occupancyCode"
                        value={formik.values.occupancyCode}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.occupancyCode &&
                          Boolean(formik.errors.occupancyCode)
                        }
                        helperText={
                          formik.touched.occupancyCode &&
                          formik.errors.occupancyCode
                        }
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        label="Loss Cost (Rate per mile)"
                        sx={{ width: '100%' }}
                        size="small"
                        name="lossCost"
                        type="number"
                        onKeyDown={(e) => {
                          if (['e', 'E', '-', '+'].includes(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        value={formik.values.lossCost}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.lossCost &&
                          Boolean(formik.errors.lossCost)
                        }
                        helperText={
                          formik.touched.lossCost && formik.errors.lossCost
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Occupancy Description"
                        sx={{ width: '100%' }}
                        size="medium"
                        type="text-area"
                        multiline
                        rows={12}
                        name="occupancyDescription"
                        value={formik.values.occupancyDescription}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.occupancyDescription &&
                          Boolean(formik.errors.occupancyDescription)
                        }
                        helperText={
                          formik.touched.occupancyDescription &&
                          formik.errors.occupancyDescription
                        }
                      />
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      spacing={3}
                      mt={2}
                    >
                      {loader ? (
                        <LoadingButton
                          sx={{ mt: { xs: 2, md: 0 } }}
                          loading={loader}
                          variant="contained"
                          type="submit"
                        >
                          Save
                        </LoadingButton>
                      ) : (
                        <LoadingButton
                          sx={{ mt: { xs: 2, md: 0 } }}
                          loading={loader}
                          variant="contained"
                          type="submit"
                        >
                          Save
                        </LoadingButton>
                      )}
                      &nbsp;
                      <Button
                        sx={{ mt: { xs: 2, md: 0 } }}
                        variant="contained"
                        color="error"
                        onClick={closeCreateEditForm}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default CreateEdit;
